import Link from 'next/link';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import { MenuItem } from '@/fo/ui/app/menu/base';

import { styles } from './Items.styles';

type NativeElement = React.HTMLAttributes<HTMLAnchorElement | HTMLDivElement>;

export interface ItemsProps {
  items?: MenuItem[];
  props?: (item: MenuItem, index: number) => NativeElement;
}

export function Items({ items = [], props }: ItemsProps) {
  const slots = styles();

  return (
    <>
      {items.map((item, index) => {
        const itemLabel = (
          <>
            <span className={item.className}>{item.label}</span>
          </>
        );

        const menuNode = (
          <>
            {item.children && item.href ? (
              <div className={slots.itemLabel()}>{itemLabel}</div>
            ) : (
              <div className={slots.itemLabel()}>{itemLabel}</div>
            )}
            {item.children && <ChevronIcon className={slots.itemIcon()} />}
          </>
        );

        const elementProps = {
          ...props?.(item, index),
          className: slots.item(),
          onClick: (
            e: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>
          ) => {
            if (item.children && item.children.length > 0) {
              e.preventDefault();
              e.stopPropagation();
            }

            props?.(item, index)?.onClick?.(e);
          }
        };

        if (item.href && !item.children) {
          return (
            <Link
              key={index}
              href={item.href}
              {...elementProps}
            >
              {menuNode}
            </Link>
          );
        }

        return (
          <div
            key={index}
            {...elementProps}
          >
            {menuNode}
          </div>
        );
      })}
    </>
  );
}
